"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import mergeSxProp from "../../../common-utils/sx/mergeSxProp.util.js";
import { useEnvironmentContext } from "../../../components/providers/Environment/index.js";
// import components
import { Suspense } from "react";
import IconAtom from "../../../icons/Icon.atom.js";
import Skeleton from "../../../components/atoms/Skeleton/index.js";
export const IconAtomComponent = (props) => {
    const { components } = useEnvironmentContext();
    if (components?.Icon)
        return _jsx(components.Icon, { ...props });
    return (_jsx(Suspense, { fallback: _jsx(Skeleton, { variant: "rounded", sx: mergeSxProp(props.sx ?? { width: 24, height: 24 }, { borderRadius: "50%" }) }), children: _jsx(IconAtom, { "data-testid": "Icon", ...props, sx: mergeSxProp({ width: 24, height: 24 }, props.sx) }) }));
};
export default IconAtomComponent;
